import React, {useState, useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import MUIDataTable from 'mui-datatables';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import {DatePicker} from '@mui/x-date-pickers';
import Button from '@mui/material/Button';

//DS
import {urlsCrm} from '../../../config/keys';
import {GroupBox, SelectPlus, SelectDs, hooks} from 'lib.front';
import {transformacion} from 'lib.common';
import {queryLlaves, queryData, queryDataVer, mutationGenerarLicencia} from './queries';
import {loadingModal, openMsg} from 'src/redux-app';
import {showSucces} from 'src/common/toast';
import {column, baseOptions} from './config';
import {esquemaCampos, esquemaValidacion} from './esquemas';
import {cmps} from './constantes';
import {createTheme, ThemeProvider} from '@mui/material';

const {denominacionCliente} = transformacion;
const {useApolloLazyQ, useValidacion, useApolloQ, useApolloMutation} = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2),
      width: '97%'
   },
   input: {
      maxWidth: '500px',
   },
   searchContainer: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
         justifyContent: 'start'
      }
   },
   groupBox: {
      marginLeft: '0px',
      paddingBottom: '5px'
   },
   blueButton: {
      borderColor: theme.palette.info.main,
      color: theme.palette.info.main,
      '&:hover': {
         backgroundColor: 'rgba(227, 239, 246, 0.5)',
         borderColor: theme.palette.info.mainlue
      }
   },
   redButton: {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
      '&:hover': {
         backgroundColor: 'rgba(238, 89, 80, 0.2)',
         borderColor: theme.palette.error.main
      }
   },
   datePicker: {
      width: '-webkit-fill-available'
   },
   datePickerGrid: {
      alignContent: 'center'
   }
}));

const tiposDocumento = ['01', '03'];

function genValue(reg) {
   return reg.codigo;
}
function genLabel(reg) {
   return reg.denominacion;
}
function genId(reg) {
   return reg.codigo;
}

function ActualizacionMasivaLicencias(props) {
   const dispatch = useDispatch();
   const {classes, cx} = useStyles();
   const {onSuccessCallback, onCloseCallback, codigoActivacion, usuario} = props;
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   //Estados de control
   const [disabled, setDisabled] = useState(false);

   //Estados
   const {
      campos,
      existeError,
      handleOnChange,
      validacionManual,
      setCampo,
      inicializar,
      validarTodos
   } = useValidacion(esquemaCampos, esquemaValidacion);

   function onBlurValidacion(e) {
      validacionManual(e.target.name, e.target.value);
   }

   //Estados
   const [cliente, setCliente] = useState(null);
   const [dataTable, setDataTable] = useState([]);
   const [searchText, setSearchText] = useState('');
   const [llavesSelecionadas, setLlavesSelecionadas] = useState([]);
   const [rowsSelectedTable, setRowsSelectedTable] = useState([]);
   //Data Generica
   const [productos, setProductos] = useState([]);
   const [versiones, setVersiones] = useState([]);
   const [presentaciones, setPresentaciones] = useState([]);
   const [modulares, setModulares] = useState([]);
   function procesarDataGenerica(data) {
      if (data['productos'] && data['productos'].length > 0) {
         setProductos(data['productos']);
         setCampo('producto', data['productos'][0].codigo);
      }
      if (data['presentaciones'] && data['presentaciones'].length > 0) {
         setPresentaciones(data['presentaciones']);
         setCampo('presentacion', data['presentaciones'][0].codigo);
      }
      if (data['versiones'] && data['versiones'].length > 0) {
         setVersiones(data['versiones']);
         setCampo('version', data['versiones'][0].codigo);
      }
      if (data['modulares'] && data['modulares'].length > 0) {
         setModulares(data['modulares']);
         setCampo('modular', data['modulares'][0].codigo);
      }
   }

   function procesarDataGenericaVersion(data) {
      if (
         data.productoDetallesOrdDesFechaCreacion &&
         data.productoDetallesOrdDesFechaCreacion.length > 0
      ) {
         const objetoVersiones = data.productoDetallesOrdDesFechaCreacion.reduce(
            (Acumulador, valorActual, Indice) => {
               Acumulador[valorActual.version.codigo] = valorActual.version;
               return Acumulador;
            },
            {}
         );
         const arrayVersiones = Object.values(objetoVersiones);
         if (arrayVersiones.length != 0) {
            setCampo('version', arrayVersiones[0].codigo);
            setVersiones(Object.values(arrayVersiones));
         } else {
            setCampo('version', arrayVersiones);
            setVersiones(Object.values(arrayVersiones));
         }
      }
   }

   function procesarDataGenericaPresentacion() {
      if (DatosFiltro && DatosFiltro?.productoDetallesOrdDesFechaCreacion.length > 0) {
         let arrayPresentacion = [];
         DatosFiltro.productoDetallesOrdDesFechaCreacion.forEach(element => {
            if (element.version.codigo === campos.version.valor) {
               arrayPresentacion.push(element.presentacion);
            }
         });
         if (arrayPresentacion.length != 0) {
            setCampo('presentacion', arrayPresentacion[0].codigo);
            setPresentaciones(arrayPresentacion);
         } else {
            setCampo('presentacion', arrayPresentacion);
            setPresentaciones(arrayPresentacion);
         }
      }
   }

   const [getVersion, {data: DatosFiltro}] = useApolloLazyQ(queryDataVer, {
      callbackProcesarData: procesarDataGenericaVersion,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   useEffect(() => {
      if (campos.producto.valor) {
         const variables = {
            codigoProducto: campos.producto.valor
         };
         getVersion({variables: variables});
      }
   }, [campos.producto.valor]);
   useEffect(() => {
      if (campos.version.valor) {
         procesarDataGenericaPresentacion();
      }
   }, [campos.version.valor]);

   useApolloQ(queryData, {
      callbackProcesarData: procesarDataGenerica,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   //Modificar las licencias generadas
   const [grabarLicencias] = useApolloMutation(mutationGenerarLicencia, {
      callbackProcesarData: procesarGenerarLicenciaData,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   async function generarParametros() {
      let dataCliente = cliente.label.split('-');
      let ruc = dataCliente[0].trim();
      let razonSocial = dataCliente[1].trim();
      let parametrosSpu = {
         ruc: ruc,
         razonsocial: razonSocial,
         tipoDoc: campos.tipoDoc.valor,
         serieDoc: campos.serieDoc.valor,
         nroDoc: campos.nroDoc.valor,
         usuario: usuario.usuario
      };
      let activacionesDatos = [];
      llavesSelecionadas.forEach(llave => {
         let datos = {
            codigo: llave.codigo,
            grupo: llave.iter,
            anio: Number(campos.anio.valor),
            producto: campos.producto.valor,
            version: campos.version.valor,
            presentacion: campos.presentacion.valor,
            modular: campos.modular.valor === '' ? null : campos.modular.valor,
            fechaExpiracion: campos.fechaExpiracion.valor
               ? `${campos.fechaExpiracion.valor.getFullYear()}-${campos.fechaExpiracion.valor.getMonth() +
                    1}-${campos.fechaExpiracion.valor.getDate()}`
               : null,
            fechaVigenciaApi: campos.fechaVigenciaApi.valor
               ? `${campos.fechaVigenciaApi.valor.getFullYear()}-${campos.fechaVigenciaApi.valor.getMonth() +
                    1}-${campos.fechaVigenciaApi.valor.getDate()}`
               : null,
            fechaVigenciaSoporte: campos.fechaVigenciaSoporte.valor
               ? `${campos.fechaVigenciaSoporte.valor.getFullYear()}-${campos.fechaVigenciaSoporte.valor.getMonth() +
                    1}-${campos.fechaVigenciaSoporte.valor.getDate()}`
               : null
            //agregar fecha de vigencia para apis
         };
         activacionesDatos.push(datos);
      });
      parametrosSpu.activaciones = activacionesDatos;

      return parametrosSpu;
   }

   async function procesarGrabar() {
      const esOkGrabar = await validarTodos();
      if (esOkGrabar) {
         const variables = await generarParametros();
         grabarLicencias({variables});
      }
   }

   async function procesarGenerarLicenciaData(data) {
      if (data['generarLicencia'] && data['generarLicencia'].msg !== '') {
         showSucces(data['generarLicencia'].msg);
         inicializarForm();
         onSuccessCallback();
         obtenerLlaves();
         setRowsSelectedTable([]);
         setLlavesSelecionadas([]);
      }
   }

   useEffect(() => {
      obtenerLlaves();
      setRowsSelectedTable([]);
      setLlavesSelecionadas([]);
   }, [cliente]);

   useEffect(() => {
      setDisabled(llavesSelecionadas.length > 0);
   }, [rowsSelectedTable]);

   function obtenerLlaves() {
      if (cliente && cliente.value !== '') {
         getLlaves({variables: {codigoCliente: cliente.value}});
      }
   }
   const [getLlaves, {data: dataLlaves}] = useApolloLazyQ(queryLlaves, {
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   useEffect(() => {
      if (dataLlaves && dataLlaves.llavesNoAnuladas) {
         setDataTable(dataLlaves.llavesNoAnuladas);
      }
      const firstTable = document.querySelector('.MuiTable-root');
      if (firstTable) {
         firstTable.classList.add('firstMuiTable');
      }
   }, [dataLlaves]);

   useEffect(() => {
      const indexes = [];
      llavesSelecionadas.forEach(llave => {
         let indexData = dataTable.indexOf(llave);
         if (indexData >= 0) {
            indexes.push(indexData);
         }
      });
      setRowsSelectedTable(indexes);
   }, [dataTable]);

   function filtroArregloData(arreglo, searchString) {
      return arreglo.filter(obj => {
         // Recorrer todas las propiedades del objeto
         for (let key in obj) {
            let value = obj[key];

            // Si el valor es un string y contiene el string de búsqueda, incluir el objeto en el resultado
            if (
               typeof value === 'string' &&
               value.toLowerCase().includes(searchString.toLowerCase())
            ) {
               return true;
            }
         }
         return false; // Si ninguna propiedad coincide, no incluir el objeto
      });
   }

   useEffect(() => {
      if (searchText !== null && searchText != '') {
         setDataTable(filtroArregloData(dataTable, searchText));
      } else {
         setDataTable(dataLlaves?.llavesNoAnuladas || []);
      }
   }, [searchText]);

   //Opciones adicionales de la tabla
   const optionAdicional = {
      rowsSelected: rowsSelectedTable,
      onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
         if (currentRowsSelected.length > 0) {
            currentRowsSelected.forEach(RowsSelected => {
               let row = dataTable[RowsSelected.dataIndex];
               if (llavesSelecionadas.includes(row)) {
                  setLlavesSelecionadas(llavesSelecionadas.filter(llave => llave != row));
               } else {
                  llavesSelecionadas.push(row);
               }
            });
         } else {
            setLlavesSelecionadas([]);
         }
         setRowsSelectedTable(rowsSelected);
      }
   };

   //Opciones de la tabla
   const options = {
      ...baseOptions,
      ...optionAdicional
   };

   function inicializarForm() {
      setDisabled(false);
      inicializar();
      onCloseCallback();
   }

   return (
      <Container className={cx('containerbox', classes.container)}>
         <Grid container spacing={3}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Actualizar llaves
               </Typography>
            </Grid>
            <Grid container item spacing={2} xs={12} lg={8}>
               <Grid item xs={12} md={6}>
                  <SelectPlus
                     url={urlsCrm.graph}
                     name="cliente"
                     label="RUC"
                     entidad="clientes"
                     campos={[
                        'codigo',
                        'nombre',
                        'apPaterno',
                        'apMaterno',
                        'razonSocial',
                        'nroDoc'
                     ]}
                     value={cliente}
                     onChange={elegido => {
                        setCliente(elegido);
                     }}
                     genId={registro => {
                        return registro.nroDoc;
                     }}
                     genLabel={denominacionCliente}
                     InputLabelProps={{shrink: true}}
                     variant="outlined"
                     margin="dense"
                     fullWidth
                     isClearable
                     excesoElementos
                     recuperarOnFocus
                     placeholder="Elija un cliente:"
                     className={classes.input}
                  />
               </Grid>
               {dataLlaves !== undefined && dataLlaves !== null && (
                  <Grid item xs={12} md={6} className={classes.searchContainer}>
                     <TextField
                        value={searchText || ''}
                        placeholder={'Buscar'}
                        onChange={event => {
                           setSearchText(event.target.value);
                        }}
                        variant="standard"
                        style={{maxWidth: '400px'}}
                        InputProps={{
                           startAdornment: (
                              <InputAdornment position="start">
                                 <SearchIcon />
                              </InputAdornment>
                           ),

                           endAdornment: (
                              <>
                                 {searchText && (
                                    <IconButton
                                       onClick={() => {
                                          setSearchText('');
                                          document.querySelector('.MuiInputBase-input').focus();
                                       }}
                                       style={{padding: '0'}}
                                       size="large"
                                    >
                                       <ClearIcon />
                                    </IconButton>
                                 )}
                              </>
                           )
                        }}
                        inputProps={{className: 'MuiInputBase-input'}}
                        fullWidth
                     />
                  </Grid>
               )}
            </Grid>
            <Grid item xs={12}>
               {dataLlaves !== undefined && dataLlaves !== null && (
                  <MUIDataTable data={dataTable} columns={column} options={options} />
               )}
            </Grid>
            <Grid container item xs={12}justifyContent={'center'}>
               <Grid item container xs={12} spacing={4}>
                  <Grid
                     item
                     container
                     xs={12}
                     style={{
                        border: '1px solid lightgray',
                        maxHeight: '380px',
                        borderRadius: '8px',
                        padding: '16px 8px 16px 0px',
                        margin: '24px 0px 0px 24px'
                     }}
                     spacing={1}
                  >
                     <Grid item md={5} sm={12}>
                        <GroupBox label="Documento" className={classes.groupBox}>
                           <Grid container spacing={1}>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectTipoDoc"
                                    name={cmps.TIPO_DOC}
                                    label="Tipo"
                                    variant="outlined"
                                    value={campos.tipoDoc.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={tiposDocumento}
                                    error={campos.tipoDoc.error !== ''}
                                    helperText={campos.tipoDoc.error}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <TextField
                                    label="Serie"
                                    name={cmps.SERIE_DOC}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    required
                                    onChange={handleOnChange}
                                    onBlur={onBlurValidacion}
                                    value={campos.serieDoc.valor}
                                    error={campos.serieDoc.error !== ''}
                                    helperText={campos.serieDoc.error}
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <TextField
                                    label="Número"
                                    name={cmps.NRO_DOC}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    required
                                    onChange={handleOnChange}
                                    onBlur={onBlurValidacion}
                                    value={campos.nroDoc.valor}
                                    error={campos.nroDoc.error !== ''}
                                    helperText={campos.nroDoc.error}
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                           </Grid>
                        </GroupBox>
                     </Grid>

                     <Grid item md={7} sm={12}>
                        <GroupBox label="Licencia" className={classes.groupBox}>
                           <Grid container spacing={1}>
                              <Grid item xs={3}>
                                 <TextField
                                    label="Año"
                                    name={cmps.ANIO}
                                    variant="outlined"
                                    margin="dense"
                                    type="number"
                                    fullWidth
                                    required
                                    onChange={handleOnChange}
                                    onBlur={onBlurValidacion}
                                    value={campos.anio.valor}
                                    error={campos.anio.error !== ''}
                                    helperText={campos.anio.error}
                                    InputLabelProps={{
                                       shrink: true
                                    }}
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                              <Grid item xs={3} className={classes.datePickerGrid}>
                                 <DatePicker
                                    name={cmps.FECHA_EXPIRACION}
                                    margin="dense"
                                    label="Fecha Expiración"
                                    format="dd/MM/yyyy"
                                    value={campos.fechaExpiracion.valor}
                                    onChange={date => {
                                       validacionManual(cmps.FECHA_EXPIRACION, date);
                                       if (date > campos.fechaVigenciaApi.valor) {
                                          validacionManual(cmps.FECHA_VIGENCIA_API, date);
                                          validacionManual(cmps.FECHA_VIGENCIA_SOPORTE, date);
                                       }
                                    }}
                                    inputVariant="outlined"
                                    KeyboardButtonProps={{
                                       'aria-label': 'elegir fecha'
                                    }}
                                    minDate={new Date()}
                                    fullWidth
                                    disabled={!disabled}
                                    className={cx(classes.input, classes.datePicker)}
                                 />
                              </Grid>
                              <Grid item xs={3} className={classes.datePickerGrid}>
                                 <DatePicker
                                    name={cmps.FECHA_VIGENCIA_API}
                                    margin="dense"
                                    label="Fecha Fin APIs"
                                    format="dd/MM/yyyy"
                                    value={campos.fechaVigenciaApi.valor}
                                    onChange={date => {
                                       validacionManual(cmps.FECHA_VIGENCIA_API, date);
                                    }}
                                    inputVariant="outlined"
                                    KeyboardButtonProps={{
                                       'aria-label': 'elegir fecha'
                                    }}
                                    minDate={new Date()}
                                    fullWidth
                                    disabled={!disabled}
                                    className={cx(classes.input, classes.datePicker)}
                                 />
                              </Grid>
                              <Grid item xs={3} className={classes.datePickerGrid}>
                                 <DatePicker
                                    name={cmps.FECHA_VIGENCIA_SOPORTE}
                                    margin="dense"
                                    label="Fecha Fin Soporte"
                                    format="dd/MM/yyyy"
                                    value={campos.fechaVigenciaSoporte.valor}
                                    onChange={date => {
                                       validacionManual(cmps.FECHA_VIGENCIA_SOPORTE, date);
                                    }}
                                    inputVariant="outlined"
                                    KeyboardButtonProps={{
                                       'aria-label': 'elegir fecha'
                                    }}
                                    minDate={new Date()}
                                    fullWidth
                                    disabled={!disabled}
                                    slotProps={{textField:{required: true}}}
                                    className={cx(classes.input, classes.datePicker)}
                                 />
                              </Grid>
                           </Grid>
                        </GroupBox>
                     </Grid>
                     <Grid item xs={12}>
                        <GroupBox label="Producto" className={classes.groupBox}>
                           <Grid container spacing={1}>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectProducto"
                                    name={cmps.PRODUCTO}
                                    label="Producto"
                                    variant="outlined"
                                    value={campos.producto.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={productos}
                                    error={campos.producto.error !== ''}
                                    helperText={campos.producto.error}  
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectVersion"
                                    name={cmps.VERSION}
                                    label="Version"
                                    variant="outlined"
                                    value={campos.version.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={versiones}
                                    error={campos.version.error !== ''}
                                    helperText={campos.version.error}
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectPresentacion"
                                    name={cmps.PRESENTACION}
                                    label="Presentacion"
                                    variant="outlined"
                                    value={campos.presentacion.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={presentaciones}
                                    error={campos.presentacion.error !== ''}
                                    helperText={campos.presentacion.error}
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                    className={classes.input}
                                 />
                              </Grid>
                              {/**
                           <Grid item xs={3}>
                              <SelectDs
                                 id="selectModular"
                                 name={cmps.MODULAR}
                                 label="Modular"
                                 variant="outlined"
                                 value={campos.modular.valor}
                                 onChange={handleOnChange}
                                 margin="dense"
                                 data={modulares}
                                 error={campos.modular.error !== ''}
                                 helperText={campos.modular.error}
                                 genItemValue={genValue}
                                 genItemKey={genId}
                                 genItemLabel={genLabel}
                                 required
                                 fullWidth
                                 disabled={!disabled}
                                 className={classes.input}
                              />
                           </Grid>
                           */}
                           </Grid>
                        </GroupBox>
                     </Grid>
                  </Grid>
                  <Grid container item xs={12} justifyContent="space-between">
                     <Grid item xs={3}>
                        <Button
                           onClick={inicializarForm}
                           variant="contained"
                           fullWidth
                        >
                           Cancelar
                        </Button>
                     </Grid>
                     <Grid item xs={3}>
                        <Button
                           onClick={procesarGrabar}
                           variant="contained"
                           disabled={!disabled || existeError}
                           fullWidth
                        >
                           Guardar
                        </Button>
                     </Grid>
                  </Grid>
               </Grid>
            </Grid>
         </Grid>
      </Container>
   );
}

ActualizacionMasivaLicencias.propTypes = {
   onSuccessCallback: PropTypes.func,
   onCloseCallback: PropTypes.func,
   codigoActivacion: PropTypes.string
};

ActualizacionMasivaLicencias.defaultProps = {
   onSuccessCallback: Data => {
      return;
   },
   onCloseCallback: () => {
      return;
   }
};

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps() {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ActualizacionMasivaLicencias);
